export class Offerte {
    ID : number;
    ObjectID : number
    ;OfferteNummer :number
    ;VerkDrukGulden : number
    ;VerkVoorbereidingGulden : number
    ;VerkCompleetGulden : number
    ;VerkDrukEuro : number
    ;VerkCompleetEuro : number
    ;VerkVoorbereidingEuro : number
    ;InvoerDatum : string
    ;Opmerking : string
    ;DatumVerstuurd : string
    ;MutatieDatum : string;
    Objectnummer : string;
}

export class OfferteInkoop {
            ID : number;
            OfferteID : number
           ;BedrijfNummer : number
           ;Toelichting : string
           ;StatusCodeID : number
           ;KostenGulden : number
           ;KostenEuro : number
           ;InvoerDatum: string
           ;MutatieDatum: string;
}

export class OfferteObject {
  ID: number;
  OfferteNummer : number;
  ObjectID: number;
  ObjectNummer: number;
  ObjectSerieNr:number;
  Contactpersoon:number;
  BedrijfNummer:number;
}


export class OfferteSelect {
  objectNR: string;
  offerteNR: string;
}


export class StatusCode {

ID: number
;StatusCode: string;
;CodeOmschrijving
;Volgorde: number
;IsCorrectie: boolean
;InvoerDatum: string;
;MutatieDatum: string;

}
